module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var fontService = require('FontService').default;

var size = fontService.getFontSizes();


    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Caption</span></div>\r\n<div class=\"prop-details\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 nopadding-r\">\r\n            <select name=\"titleFontFamily\" class=\"style-font\"  id=\"titleFontFamily\">\r\n               \r\n            </select>\r\n        </div>\r\n        <div class=\"col-md-6\" style=\"text-align: right;\">\r\n            <select name=\"titleFontSize\" id=\"titleFontSize\" class=\"style-font\" style=\"width: 45px;\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                    <option value=\"")
    ; __append(escapeFn( size[i] ))
    ; __append("\">")
    ; __append(escapeFn( size[i] ))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 subsection nopadding-r\">\r\n            <div>\r\n                <div id=\"main_text_font_family_custom\">\r\n                    <input id=\"customTitleFontFamily\" style=\"margin-bottom:2px;\" name=\"customTitleFontFamily\" type=\"text\" value=\"")
    ; __append(escapeFn( customTitleFontFamily ))
    ; __append("\" ")
    ; __append(escapeFn( customTitleFontFamilyDisabled ))
    ; __append("/>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-8\">\r\n            <input id=\"titleColorPicker\" name=\"titleColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( titleColor ))
    ; __append("\"\r\n                   style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\"/>\r\n            <input id=\"titleColor\" name=\"titleColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\"\r\n                   value=\"")
    ; __append(escapeFn( titleColor ))
    ; __append("\"/>\r\n        </div>\r\n        <div class=\"col-md-4\" style=\"text-align: right;\">\r\n            <img id=\"titleBoldText\" name=\"titleTextWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\"\r\n                 style=\"width: 20px; height: 20px; background-color: ")
    ; __append(escapeFn( titleBoldSelection ))
    ; __append("\"/>\r\n            <img id=\"titleItalicText\" name=\"titleTextStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"\r\n                 style=\"width: 20px; height: 20px; background-color: ")
    ; __append(escapeFn( titleItalicSelection ))
    ; __append("\"/>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}